import React, { PropsWithChildren } from 'react'
import classes from './Table.module.scss'
import { getCellStyle } from '@/components/ui/Table/utils'

export type CellProps = PropsWithChildren<{
  size?: number | string
  isCentered?: boolean
}>

const Cell = ({ size = 1, isCentered = false, children }: CellProps) => (
  <div className={classes.cell} style={getCellStyle(size, isCentered)}>
    {children}
  </div>
)

export default Cell
